



















import { defineComponent, ref, set } from "@vue/composition-api";
import emitter from "@/lib/emitter";
import { $t } from "@/lib/i18nHelpers";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BasePage from "@/components/BasePage";
import BaseSpinner from "@/components/BaseSpinner";
import PageTitle from "@/components/PageTitle";
import PayoutForm from "@/components/PayoutForm";

export default defineComponent({
  name: "PagePayeeInfoEdit",
  components: { BaseButton, PayoutForm, PageTitle, BasePage, BaseSpinner },
  setup(_, { root }) {
    const loading = ref(false);
    const valid = ref(false);
    const submits: Record<string, () => Promise<any>> = {};

    const setCb = (stepName: string, cb: Promise<any>) => {
      set(submits, stepName, cb);
    };

    const onSubmit = async () => {
      try {
        loading.value = true;
        for (let key in submits) {
          await submits[key]?.();
        }
        emitter.emit(EVENTS.NOTIFICATION_SHOW, { text: $t("Changes have been saved"), timeout: 2000 });
        root.$router.replace({ name: "profilePayeeInfo" });
      } catch (e) {
        console.error(e);
        return;
      } finally {
        loading.value = false;
      }
    };

    return {
      loading,
      valid,
      setCb,
      onSubmit,
    };
  },
});
